module.exports = __webpack_public_path__ + "static/img/vrroad_contactbg.79af617c.png";